import z from "zod";

export const selectDirectiveEntrySchema = z.object({
  directive_entry_type: z.string({ message: 'Selecione um encaminhamento de processo' }),
});

export type SelectDirectiveEntryValidationSchema = z.infer<typeof selectDirectiveEntrySchema>;
